import { Navigate, useRoutes } from "react-router";

import { Spinner } from "@prequel/shared-components";

import LoginCard from "./LoginCard";
import LoginSuccessfulCard from "./LoginSuccessfulCard";

import { useAuthStatus } from "@/api/queries/auth";

type AuthenticationProps = {
  children: React.ReactNode;
};
const Authentication = ({ children }: AuthenticationProps) => {
  const { isSuccess, isError } = useAuthStatus();

  // Determine the unauthenticated route to render based on the path
  const unauthenticatedElement = useRoutes([
    { path: "/login", element: <LoginCard /> },
    { path: "/login-successful", element: <LoginSuccessfulCard /> },
    { path: "*", element: <Navigate to="/login" replace /> },
  ]);

  // authenticated is undefined if the frontend does not know the auth state
  // authenticated is true if the user is authenticated
  // authenticated is false if the user is not authenticated
  const authenticated = isSuccess ? true : isError ? false : undefined;
  if (authenticated === undefined) {
    return (
      <main className="h-screen w-screen bg-gray-50">
        <Spinner />
      </main>
    );
  }

  // If authenticated, render children and ignore unauthenticated routes
  if (authenticated) {
    return <>{children}</>;
  }

  return <main className="h-screen w-screen bg-gray-50">{unauthenticatedElement}</main>;
};

export default Authentication;
